import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./ContactUs.css";
import HomeIcon from '@material-ui/icons/Home';
import PhoneIcon from '@material-ui/icons/Phone';
import MailIcon from '@material-ui/icons/Mail';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import PinterestIcon from '@material-ui/icons/Pinterest';

function ContactUs() {
	return (
		<div className="contactUs">
			<NavBar page="contactUs"/>
				<div className="contactUs__home">
					<h1 className="contactUs__homeTitle"> Contact Us </h1>
					<div className="aboutUs__socialMediaIcons">
						<div className="aboutUs__socialMediaIcon">
							<HomeIcon style={{fontSize: "40px", color: "#fff"}}/>
							<div>  38 Alexander Ave, Devon ParK SA 5008 </div>
						</div>
						<div className="aboutUs__socialMediaIcon">
							<PhoneIcon style={{fontSize: "40px", color: "#fff"}}/>
							<div>   +61 032 004 8339 </div>
						</div>
						<div className="aboutUs__socialMediaIcon">
							<MailIcon style={{fontSize: "40px", color: "#fff"}}/>
							<div>   ASO5S@gmail.com </div>
						</div>
					</div>
					<h1 className="contactUs__homeTitle"> Contact us on social media </h1>
					<div className="aboutUs__socialMediaIcons">
						<div className="aboutUs__socialMediaIcon">
							<FacebookIcon style={{fontSize: "40px", color: "#39569c"}}/>
							<div> Facebook </div>
						</div>
						<div className="aboutUs__socialMediaIcon">
							<TwitterIcon style={{fontSize: "40px", color: "#26A7DE"}}/>
							<div> Twitter </div>
						</div>
						<div className="aboutUs__socialMediaIcon">
							<InstagramIcon style={{fontSize: "40px", color: "#DD2A7B"}} />
							<div> Instagram </div>
						</div>
						<div className="aboutUs__socialMediaIcon">
							<PinterestIcon style={{fontSize: "40px", color: "rgb(189, 8, 28)"}} />
							<div> Pinterest </div>
						</div>
						</div>
				</div>
			<Footer />
		</div>
	)
}


export default ContactUs;